import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Models } from '../../models/global.models';

function createInitialState(): Models.BorrowerInformationLeadForm {
  return <Models.BorrowerInformationLeadForm>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'borrower-lead-store' })
export class BorrowerLeadStore extends Store<Models.BorrowerInformationLeadForm> {
  constructor() {
    super(createInitialState());
  }
}
